import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {NgForOf, NgIf} from "@angular/common";
import {SwiperComponent, SwiperModule} from "swiper/angular";
import {SynapiItemComponent} from "../synapi-item/synapi-item.component";
import SwiperCore, {FreeMode, Mousewheel, Navigation, Pagination, Scrollbar, SwiperOptions} from "swiper";
import {MediaAttachmentComponent} from "../media-attachment/media-attachment.component";
import {NgxSmartModalComponent} from "ngx-smart-modal";
SwiperCore.use([Mousewheel,Navigation,FreeMode]);
@Component({
  selector: 'synapi-item-gallery',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    SwiperModule,
    SynapiItemComponent,
    MediaAttachmentComponent
  ],
  templateUrl: './synapi-item-gallery.component.html',
  styleUrl: './synapi-item-gallery.component.scss'
})
export class SynapiItemGalleryComponent implements AfterViewInit{
  @Input() item :SynapiItem;
  @Input() index :number;
  @Input() modal :NgxSmartModalComponent;
  @ViewChild("swiper", { static: false }) swiperComponent?: SwiperComponent;

  public config_swiper: SwiperOptions = {
    pagination: false,
    modules: [Mousewheel,Navigation,FreeMode],
    slidesPerView: "auto",
    navigation: true,
    scrollbar: false,
    mousewheel: true,
    centeredSlides: true,
    spaceBetween: 30,
    freeMode: true
  };

  ngAfterViewInit() {
    if(this.swiperComponent?.swiperRef){
      this.swiperComponent.swiperRef.slideTo(this.index);
    }
  }
}
